<template>
    <div class="objects__object">
        <div class="objects__address">
            <h3>{{ object.street }} {{ ( object.housenumber ? object.housenumber : '' ) + ( object.housenumber_addition ? ' ' + object.housenumber_addition : '' ) }} <small>{{ object.inspection_type | inspectionType }}</small></h3>
            <p>{{ object.city }}</p>
            <p>Code: {{ object.token }}</p>
        </div>

        <!--        <div class="objects__inspector">-->
        <!--            <strong>Opname expert(s)</strong>-->
        <!--            <p>{{ object.schedule.map( ( schedule ) => { return schedule.inspectors.map( ( inspector ) => { return inspector.name } ) } ) | formatExperts }}</p>-->

        <!--            <strong>Opname datum</strong>-->
        <!--            <p>{{ object.schedule | formatDates }}</p>-->
        <!--        </div>-->

        <div class="objects__status">
            <strong>Status</strong>
            <p :class="'status-' + getStatus">{{ getStatus | formatStatus }}</p>
        </div>

        <div class="objects__status">
            <strong>Afgeronde opnames</strong>
            <p>{{ object.schedule | completedInspections }} van {{ object.schedule.length }}</p>
        </div>


        <div class="objects__author" v-permission:manage_objects="currentUser">
            <strong>Ingevoerd door</strong>
            <p>{{ object.author.name }}</p>
        </div>

        <div class="objects__options">
            <ul class="dotted-dropdown">
                <li>
                    <a href="#" @click.prevent>
                        <img src="/img/icon-dots.svg" alt="" width="45" height="45">
                    </a>

                    <ul>
                        <li>
                            <router-link :to="{ name: 'onlineDossier', params: { token: object.token } }" target="_blank">Online dossier</router-link>
                        </li>
                        <li><a href="#" v-permission:manage_projects="currentUser" @click.prevent="toggleSchedulePopup">Planning</a></li>
                        <li><a href="#" @click.prevent="toggleReportsPopup" v-if="object.reports.length > 0">Rapporten</a></li>
                        <li><a href="#" v-permission:manage_objects="currentUser" @click.prevent="generateReport" v-if="getStatus > 1">Rapport genereren</a></li>
                        <li><a href="#" v-permission:manage_objects="currentUser" @click.prevent="toggleEditPopup">Bewerken</a></li>
                        <li><a href="#" v-permission:manage_projects="currentUser" @click.prevent="toggleCompleteObject" v-if="canCompleteObject">Afronden</a></li>
                    </ul>
                </li>
            </ul>
        </div>

        <EditObject :object="object" v-if="editObject" @togglePopup="toggleEditPopup"></EditObject>
        <Schedule :object="object" :startDate="project.startDate" v-if="scheduleObject" @togglePopup="toggleSchedulePopup"></Schedule>
        <Reports :object="object" v-if="reportsPopup" @togglePopup="toggleReportsPopup"></Reports>
        <CompleteObject :object="object" v-if="completeObject" @togglePopup="toggleCompleteObject"></CompleteObject>
    </div>
</template>

<script>
    //	import moment from 'moment'
    import {mapGetters} from 'vuex'
    import ProjectStatus from '@/utilities/mapping/ProjectStatus'
    import EditObject from '@/components/objects/EditObject'
    import Schedule from '@/components/objects/Schedule'
    import Reports from '@/components/objects/Reports'
    import CompleteObject from '@/components/objects/CompleteObject'
    import {GENERATE_OBJECT_REPORT} from "../../store/modules/objects";

    export default {
        components: {Schedule, EditObject, Reports, CompleteObject},

        props: ['object', 'project'],

        mounted() {
            console.log(this.object)
        },

        data() {
            return {
                editObject: false,
                scheduleObject: false,
                reportsPopup: false,
                completeObject: false,
            }
        },

        computed: {
            ...mapGetters([
                'currentUser',
            ]),

            getStatus() {
                let inspectionAmount = this.object.schedule.length

                if (this.object.schedule.length === 0) {
                    return 0
                }

                if (this.object.schedule.filter((schedule) => {
                    return schedule.status === 3
                }).length === inspectionAmount) {
                    return 3
                }

                if (this.object.schedule.filter((schedule) => {
                    return schedule.status > 1
                }).length > 0) {
                    return 2
                }

                return 1
            },

            canCompleteObject() {
                return this.object.schedule.filter((schedule) => {
                    return schedule.status === 3
                }).length !== this.object.schedule.length
            },
        },

        methods: {
            toggleEditPopup() {
                this.editObject = !this.editObject
            },

            toggleSchedulePopup() {
                this.scheduleObject = !this.scheduleObject
            },

            toggleReportsPopup() {
                this.reportsPopup = !this.reportsPopup
            },

            toggleCompleteObject() {
                this.completeObject = !this.completeObject
            },

            generateReport() {
                this.$store.dispatch(GENERATE_OBJECT_REPORT, this.object).then( () => {
                    alert('Het rapport wordt op de achtergrond gegenereerd. Dit kan enkele minuten duren. Ververs de pagina om het resultaat te bekijken.');
                });
            }
        },

        filters: {
            formatStatus(value) {
                return ProjectStatus[value]
            },

            completedInspections(value) {
                return value.filter((schedule) => {
                    return schedule.status === 3
                }).length
            },

            inspectionType(value) {
                return (
                    value === 2 ? '(Infra)' : ''
                )
            },
        },
    }
</script>